import { CAPTAINED_FIELD } from '../../../constants';

// eslint-disable-next-line import/prefer-default-export
export const captainedGetter = ({ trip, offer }) => offer.get(
  CAPTAINED_FIELD,
  trip.get(CAPTAINED_FIELD, true),
);
